import {nextUpgradePlan, Plan} from "../gating";
import {recipientLimitLabel} from "../../pricing/planEntitlements";
import type {Locale} from "i18n/localePreference";

export interface RecipientLimitCopy {
	limitUpgrade: (currentPlan: string, currentLimit: string, nextPlan: string, nextLimit: string) => string;
	limitExceeded: (plan: string, limit: string) => string;
}

/** Localized current/next tier guidance backed exclusively by the generated plan catalogue. */
export function recipientLimitMessage(
	plan: Plan,
	planNames: Record<Plan, string>,
	unlimitedLabel: string,
	copy: RecipientLimitCopy,
	locale: Locale,
): string {
	const currentLimit = recipientLimitLabel(plan, unlimitedLabel, locale);
	const nextPlan = nextUpgradePlan(plan);
	return nextPlan === null
		? copy.limitExceeded(planNames[plan], currentLimit)
		: copy.limitUpgrade(
			planNames[plan],
			currentLimit,
			planNames[nextPlan],
			recipientLimitLabel(nextPlan, unlimitedLabel, locale),
		);
}
